import { createSlice, isAction } from "@reduxjs/toolkit";
import {
  fetchDistrictById,
  fetchDistricts,
  updateDistrict,
  updateStatusInDist,
} from "./thunk";

interface DistrictState {
  districtList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedDistrict: any;
}

const initialState: DistrictState = {
  districtList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedDistrict: null,
};

const districtSlice = createSlice({
  name: "district",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDistricts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDistricts.fulfilled, (state, action) => {
        state.loading = false;
        state.districtList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchDistricts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch districts";
      })
      .addCase(fetchDistrictById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDistrictById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedDistrict = action.payload;
      })
      .addCase(fetchDistrictById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateDistrict.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.districtList = state.districtList.map((dist) =>
          dist.id === action.payload.id ? action.payload : dist
        );
      })
      .addCase(updateDistrict.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update districts";
      })
      .addCase(updateStatusInDist.fulfilled, (state, action) => {
        if (!action.payload?.data.id) return;
        // state.districtList = state.districtList.map((dist) =>
        //   dist.id === action.payload.data.id ? action.payload.data : dist
        // );
      })

      .addCase(updateStatusInDist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch districts";
      });
  },
});

export default districtSlice.reducer;
